export const ErrorPage = () => {
  return <h1 style={{ textAlign: "center" }}>404 Not Found</h1>;
};
